import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { InputTextComponent } from '../../../../../components/prime-formik';

const SuperProfileInternalNameInput = () => {
  return (
    <div className="p-col-12">
      <FormattedMessage
        id="account.super-profiles.new.internal-name.label"
        defaultMessage="Internal SuperProfile name"
      >
        {(text) => (
          <label className="field-label" htmlFor="internalName">
            <strong>{text}</strong>
          </label>
        )}
      </FormattedMessage>
      <FormattedMessage
        id="account.super-profiles.new.internal-name.placeholder"
        defaultMessage="Enter the internal name of this SuperProfile"
      >
        {(text) => (
          <Field
            id="internalName"
            name="internalName"
            component={InputTextComponent}
            className="width-full"
            placeholder={text}
          />
        )}
      </FormattedMessage>
    </div>
  );
};

export default SuperProfileInternalNameInput;
